/**
 * Modal.js
 * Temporary file to be used for the Tag and TagGroup Modal component once its moved to corecanvas-services this file will be get deleted.
 */
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import MotifModalBody from '@ey/motif-react-wrapper/ModalBody';
import MotifModalHeader from '@ey/motif-react-wrapper/ModalHeader';
import MotifModalFooter from '@ey/motif-react-wrapper/ModalFooter';
import MotifButton from '@ey/motif-react-wrapper/Button';
import MotifModal from '@ey/motif-react-wrapper/Modal';
import MotifIconButton from '@ey/motif-react-wrapper/IconButton';
import Ellipse from '@ey/canvascoreservices/Ellipse';
import {SVGICONS} from '@ey/icons';
import MotifIcon from '@ey/motif-react-wrapper/Icon';
import {MotifNavigationIcClose24px} from '@ey-xd/motif-icon';

const Modal = (props) => {
	const {
		show,
		onHide,
		onOkClick,
		onSaveCreateClick,
		title,
		children,
		isOkButtonDisabled,
		isCancelButtonDisabled,
		isSaveCreateButtonDisabled,
		showButtons,
		hideCloseButton,
		hideConfirmButton,
		hideCancelButton,
		confirmBtnTitle,
		closeBtnTitle,
		closeTitle,
		saveCreateBtnTitle,
		modalsize,
		modalBodyStyle,
		modalContainerClass,
		modalonmodal,
		disableClose,
		focusTrapOptions,
		showError = false,
		errorChildren,
		closeBtnVariant = 'ghost'
	} = props;

	return (
		<StyledMotifModal
			show={show}
			onClose={onHide}
			className={modalsize + ' ' + modalContainerClass}
			modalonmodal={modalonmodal}
			focusTrapOptions={
				focusTrapOptions ? focusTrapOptions : {allowOutsideClick: true, activeTrap: false, initialFocus: '#focusTrap'}
			}
		>
			<div id="focusDiv" tabIndex="-1" />
			<StyledModalHeader
				visibility={hideCloseButton}
				closeModalButton={
					<MotifButton
						variant="ghost"
						onClick={onHide}
						className="motif-modal--header-icon-button"
						title={closeTitle || closeBtnTitle}
						disabled={disableClose}
					>
						<span title={closeTitle || closeBtnTitle}>
							<MotifIcon src={MotifNavigationIcClose24px} title={closeTitle || closeBtnTitle} />
						</span>
					</MotifButton>
				}
			>
				{title}
			</StyledModalHeader>
			<React.Fragment>
				<StyledModalBody className={modalBodyStyle}>
					{showError && <section className="errorChild"> {errorChildren}</section>}
					{children}
				</StyledModalBody>
				{showButtons && (
					<StyledModalFooter>
						{!hideCancelButton && (
							<MotifButton
								type="button"
								variant={closeBtnVariant}
								size="medium"
								disabled={isCancelButtonDisabled}
								onClick={onHide}
							>
								<span className="ellipseWrapper">
									<Ellipse content={closeTitle || closeBtnTitle} tooltip={closeTitle || closeBtnTitle} noOfLines={1} />
								</span>
							</MotifButton>
						)}
						{saveCreateBtnTitle && (
							<MotifButton
								type="button"
								variant="secondary"
								size="medium"
								disabled={isSaveCreateButtonDisabled}
								onClick={onSaveCreateClick}
							>
								<span className="ellipseWrapper">
									<Ellipse content={saveCreateBtnTitle} tooltip={saveCreateBtnTitle} noOfLines={1} />
								</span>
							</MotifButton>
						)}
						{!hideConfirmButton && (
							<MotifButton
								type="button"
								variant="primary"
								size="medium"
								onClick={onOkClick}
								disabled={isOkButtonDisabled}
							>
								<span className="ellipseWrapper">
									<Ellipse content={confirmBtnTitle} tooltip={confirmBtnTitle} noOfLines={1} />
								</span>
							</MotifButton>
						)}
					</StyledModalFooter>
				)}
			</React.Fragment>
		</StyledMotifModal>
	);
};

export default Modal;

const StyledMotifModal = styled(MotifModal)`
	&.motif-modal {
		width: 100%;
		height: 100%;
		max-height: 100%;
		position: relative;
		&.x-small {
			width: 30%;
			max-width: 30%;
			height: auto !important;
		}
		&.small {
			width: 50%;
			max-width: 50%;
			height: auto !important;
		}
		&.medium {
			width: 72%;
			max-width: 72%;
			height: calc(100vh - var(--px-40)) !important;
		}
		&.large {
			width: 95%;
			max-width: 95%;
			height: calc(100vh - var(--px-40)) !important;
		}
		&.takeover {
			width: 100% !important;
			height: 100% !important;
			max-width: 100% !important;
			max-height: 100% !important;
			position: fixed !important;
		}
	}
	.motif-modal-body {
		position: relative;
		flex-grow: 1;
		.customScrollbar {
			overflow-y: auto;
			&::-webkit-scrollbar {
				width: var(--px-6);
			}
			&::-webkit-scrollbar-track {
				background: var(--neutrals-200);
				width: var(--px-6);
			}
			&::-webkit-scrollbar-thumb {
				background: var(--neutrals-300);
				width: var(--px-6);
				cursor: pointer;
			}
			&::-webkit-scrollbar-thumb:hover {
				background: var(--neutrals-700);
			}
		}
		&.editReply {
			min-height: var(--px-340) !important;
		}
		.add-note-wrapper {
			min-height: var(--px-500);
			padding: 0 var(--px-25);
		}
		.deleteNoteHeading {
			padding: var(--px-15) var(--px-20);
		}
	}
`;

const StyledModalHeader = styled(MotifModalHeader)`
	&.motif-modal-header {
		height: auto;
		.motif-modal--header-icon-button {
			${({visibility}) => visibility && `visibility: hidden;`}
		}
		.motif-button {
			&:disabled {
				svg {
					cursor: not-allowed;
				}
			}
		}
	}
`;

const StyledModalBody = styled(MotifModalBody)`
	&.motif-modal-body {
		overflow: auto;
		/* height: calc(100% - var(--px-110)); */
		&.modalMinHeight {
			min-height: var(--px-200);
		}
		.modal-error-wrapper > section {
			display: flex;
			justify-content: center;
			&.modal-messages-container {
				margin: 0 !important;
			}
		}
		.errorMessageWrapper {
			margin: 0 var(--px-22) !important;
			position: absolute;
			width: 95%;
			/* min-width: var(--px-545); */
			z-index: 5;
			top: var(--px-10) !important;
			.errorIcon {
				height: auto !important;
				background-position-y: center;
			}
			.error-message {
				padding-left: var(--px-15) !important;
			}
			.motif-icon {
				color: var(--red-600);
			}
		}
	}
`;

const StyledModalFooter = styled(MotifModalFooter)`
	.motif-button {
		.ellipseWrapper {
			max-width: 100%;
		}
	}
	.ellipseWrapper {
		max-width: 100%;
	}
	.cancel-btn {
		max-width: 20%;
		min-width: unset;
	}
	.motif-button-secondary {
		max-width: 38%;
		min-width: unset;
	}
	.motif-button-primary {
		max-width: 38%;
		min-width: unset;
	}
`;

Modal.propTypes = {
	hideCloseButton: PropTypes.bool,
	focusTrapOptions: PropTypes.shape({
		allowOutsideClick: PropTypes.bool
	})
};

Modal.defaultProps = {
	focusTrapOptions: {
		allowOutsideClick: true
	}
};
